import { useEffect, useState } from "react";
import { getAppVersionLabel, getBuildVersionJsonUrl } from "../config/appVersion";

/**
 * Shows the baked-in bundle label immediately, then replaces it with the
 * value from `public/build-version.json` (same counter the generator wrote)
 * so a full browser refresh always matches the last `npm start` / `npm run build`.
 */
export function useLiveBuildVersionLabel() {
  const [label, setLabel] = useState(() => getAppVersionLabel());

  useEffect(() => {
    let cancelled = false;
    const url = `${getBuildVersionJsonUrl()}?t=${Date.now()}`;
    fetch(url, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data || typeof data.label !== "string") return;
        const next = data.label.trim();
        if (next) setLabel(next);
      })
      .catch(() => {
        /* keep bundled fallback */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return label;
}
